// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.slurry-view-container {
  padding: 15px;
  background: #fff;
  min-height: 100vh;
  font-size: 12px;
}

/* Inherit NextPage .form-control styles */
.slurry-view-container input[type="text"],
.slurry-view-container input[type="number"],
.slurry-view-container textarea,
.slurry-view-container select {
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 12px;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.slurry-view-container input:focus,
.slurry-view-container textarea:focus,
.slurry-view-container select:focus {
  border-color: #80bdff;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.slurry-view-container input[readonly] {
  background-color: #e9ecef;
  cursor: default;
}

.slurry-view-container select {
  display: inline-block;
  width: auto !important;
}

.slurry-view-container textarea {
  min-height: 120px;
}

/* Breadcrumb */
.breadcrumb-row {
  font-size: 13px;
  margin-bottom: 10px;
  color: #6B6D6F;
}

.breadcrumb-link {
  color: #0066B2;
  cursor: pointer;
  text-decoration: underline;
}

.breadcrumb-link:hover { color: #004080; }

/* Header & Fields */
.header-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px;
  border: 1px solid #DBDCDD;
  border-bottom: none;
}

.ufid-field { width: 180px; }
.status-field { width: 120px; }

/* Tabs */
.tabbed {
  border: 1px solid #8C8F93;
}

.tabs {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
}

.tabs li {
  flex: 1;
  padding: 7px 4px;
  font-size: 11px;
  cursor: pointer;
  color: #0066B2;
  font-weight: 500;
  text-align: center;
  transition: background 0.15s;
}

.tabs li[aria-selected="true"] {
  color: #0B2D71;
  font-weight: 600;
  border-bottom: 4px solid #0B2D71;
  padding-bottom: 0;
}

.tab-content[aria-hidden="true"] {
  display: none;
}

.placeholder-tab {
  padding: 30px 20px;
  color: #888;
  text-align: center;
}

/* Sections */
.section {
  border: 1px solid #ccc;
  margin: 10px 12px;
}

.section-header {
  background: #0066B2;
  border-bottom: 1px solid #0B2D71;
  padding: 6px 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.section-title {
  font-weight: 600;
  color: #fff;
  font-size: 13px;
}

.slurry-info-content,
.dry-materials-inputs {
  padding: 12px;
}

/* Form Rows */
.time-inputs-row,
.cement-row,
.blend-container-row,
.notes-section {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}

.notes-section {
  margin-top: 12px;
}

.time-inputs-row label { width: 280px; }
.cement-row label { width: 150px; }

/* Input Widths */
.time-input { width: 200px; }
.cement-input { width: 120px; text-align: right; }
.blend-input { width: 200px; }
.calculated-input { width: 80px; text-align: right; }
.notes-textarea { flex: 1; resize: vertical; }

/* Metrics */
.metrics-row {
  display: flex;
  gap: 15px;
  margin-bottom: 10px;
}

.metric-group {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
}

.metric-input {
  flex: 1;
  text-align: right;
}

/* Blend Section */
.blend-section {
  margin: 10px 12px;
}

.blend-header {
  font-weight: 600;
  color: #0B2D71;
  font-size: 13px;
  margin-bottom: 8px;
}

/* Tables */
.blend-table,
.liquid-table {
  width: 100%;
  font-size: 11px;
  margin-bottom: 8px;
}

.blend-table th,
.liquid-table th {
  padding: 6px 8px;
  font-weight: 600;
  font-size: 11px;
  white-space: nowrap;
}

.blend-table td,
.liquid-table td {
  padding: 2px;
  text-align: center;
}

/* Table Inputs */
.numeric-input {
  font-size: 11px;
  text-align: right;
}

.container-input,
.material-select {
  font-size: 11px;
}

/* Buttons */
.delete-btn {
  color: #E21836;
  font-size: 18px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  width: 15px;
}

.edit-btn,
.icon-btn {
  padding: 3px 10px 3px 8px;
  background: #0066B2;
  border: 1px solid #0066B2;
  color: #fff;
  font-size: 11px;
  cursor: pointer;
  border-radius: 2px;
}

.edit-btn:hover,
.icon-btn:hover {
  background: #004d8a;
  border-color: #004d8a;
}

.edit-btn::after {
  content: '›';
  margin-left: 4px;
  font-size: 16px;
  font-weight: bold;
  display: inline-block !important;
}

.add-btn {
  padding: 5px 15px;
  background: #0066B2;
  color: #fff !important;
  border: none;
  font-size: 11px;
  cursor: pointer;
  border-radius: 3px;
  margin-top: 5px;
}

/* Checkbox Toggle */
.hidden-input {
  display: none;
}

input[type="checkbox"]:checked ~ .hidden-input {
  display: block;
}

input[type="checkbox"]:checked ~ .add-btn {
  display: none;
}

/* Footer & Validation */
.footer-actions {
  display: flex;
  gap: 8px;
  padding: 12px 15px;
  border: 1px solid #DBDCDD;
  border-top: 2px solid #DBDCDD;
}

.validation-message {
  color: #E21836;
  padding: 4px 0;
  margin: 8px 0 8px 12px;
  font-size: 12px;
}

.validation-message-inline {
  color: #E21836;
  margin-top: 4px;
  margin-left: 8px;
  font-size: 11px;
  display: inline-block;
}

/* Remove NextPage button arrows */
.icon-btn::after,
.add-btn::after {
  display: none !important;
}`, "",{"version":3,"sources":["webpack://./projects/cemsys/src/app/project-details/slurry-view/slurry-view.component.css"],"names":[],"mappings":";AACA;EACE,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA,0CAA0C;AAC1C;;;;EAIE,cAAc;EACd,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;EACtB,wEAAwE;AAC1E;;AAEA;;;EAGE,qBAAqB;EACrB,UAAU;EACV,gDAAgD;AAClD;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,eAAe;AACf;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,0BAA0B;AAC5B;;AAEA,yBAAyB,cAAc,EAAE;;AAEzC,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,cAAc,YAAY,EAAE;AAC5B,gBAAgB,YAAY,EAAE;;AAE9B,SAAS;AACT;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;AACpB;;AAEA,aAAa;AACb;EACE,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;;EAEE,aAAa;AACf;;AAEA,cAAc;AACd;;;;EAIE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,yBAAyB,YAAY,EAAE;AACvC,oBAAoB,YAAY,EAAE;;AAElC,iBAAiB;AACjB,cAAc,YAAY,EAAE;AAC5B,gBAAgB,YAAY,EAAE,iBAAiB,EAAE;AACjD,eAAe,YAAY,EAAE;AAC7B,oBAAoB,WAAW,EAAE,iBAAiB,EAAE;AACpD,kBAAkB,OAAO,EAAE,gBAAgB,EAAE;;AAE7C,YAAY;AACZ;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,OAAO;AACT;;AAEA;EACE,OAAO;EACP,iBAAiB;AACnB;;AAEA,kBAAkB;AAClB;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA,WAAW;AACX;;EAEE,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;;EAEE,YAAY;EACZ,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;;EAEE,eAAe;AACjB;;AAEA,YAAY;AACZ;EACE,cAAc;EACd,eAAe;EACf,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,WAAW;AACb;;AAEA;;EAEE,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;;AAEA,oBAAoB;AACpB;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;EAClB,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,cAAc;EACd,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA,kCAAkC;AAClC;;EAEE,wBAAwB;AAC1B","sourcesContent":["\n.slurry-view-container {\n  padding: 15px;\n  background: #fff;\n  min-height: 100vh;\n  font-size: 12px;\n}\n\n/* Inherit NextPage .form-control styles */\n.slurry-view-container input[type=\"text\"],\n.slurry-view-container input[type=\"number\"],\n.slurry-view-container textarea,\n.slurry-view-container select {\n  display: block;\n  width: 100%;\n  padding: 0.375rem 0.75rem;\n  font-size: 12px;\n  line-height: 1.5;\n  color: #495057;\n  background-color: #fff;\n  border: 1px solid #ced4da;\n  border-radius: 0.25rem;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n\n.slurry-view-container input:focus,\n.slurry-view-container textarea:focus,\n.slurry-view-container select:focus {\n  border-color: #80bdff;\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n}\n\n.slurry-view-container input[readonly] {\n  background-color: #e9ecef;\n  cursor: default;\n}\n\n.slurry-view-container select {\n  display: inline-block;\n  width: auto !important;\n}\n\n.slurry-view-container textarea {\n  min-height: 120px;\n}\n\n/* Breadcrumb */\n.breadcrumb-row {\n  font-size: 13px;\n  margin-bottom: 10px;\n  color: #6B6D6F;\n}\n\n.breadcrumb-link {\n  color: #0066B2;\n  cursor: pointer;\n  text-decoration: underline;\n}\n\n.breadcrumb-link:hover { color: #004080; }\n\n/* Header & Fields */\n.header-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px;\n  border: 1px solid #DBDCDD;\n  border-bottom: none;\n}\n\n.ufid-field { width: 180px; }\n.status-field { width: 120px; }\n\n/* Tabs */\n.tabbed {\n  border: 1px solid #8C8F93;\n}\n\n.tabs {\n  display: flex;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.tabs li {\n  flex: 1;\n  padding: 7px 4px;\n  font-size: 11px;\n  cursor: pointer;\n  color: #0066B2;\n  font-weight: 500;\n  text-align: center;\n  transition: background 0.15s;\n}\n\n.tabs li[aria-selected=\"true\"] {\n  color: #0B2D71;\n  font-weight: 600;\n  border-bottom: 4px solid #0B2D71;\n  padding-bottom: 0;\n}\n\n.tab-content[aria-hidden=\"true\"] {\n  display: none;\n}\n\n.placeholder-tab {\n  padding: 30px 20px;\n  color: #888;\n  text-align: center;\n}\n\n/* Sections */\n.section {\n  border: 1px solid #ccc;\n  margin: 10px 12px;\n}\n\n.section-header {\n  background: #0066B2;\n  border-bottom: 1px solid #0B2D71;\n  padding: 6px 12px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.section-title {\n  font-weight: 600;\n  color: #fff;\n  font-size: 13px;\n}\n\n.slurry-info-content,\n.dry-materials-inputs {\n  padding: 12px;\n}\n\n/* Form Rows */\n.time-inputs-row,\n.cement-row,\n.blend-container-row,\n.notes-section {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 10px;\n}\n\n.notes-section {\n  margin-top: 12px;\n}\n\n.time-inputs-row label { width: 280px; }\n.cement-row label { width: 150px; }\n\n/* Input Widths */\n.time-input { width: 200px; }\n.cement-input { width: 120px; text-align: right; }\n.blend-input { width: 200px; }\n.calculated-input { width: 80px; text-align: right; }\n.notes-textarea { flex: 1; resize: vertical; }\n\n/* Metrics */\n.metrics-row {\n  display: flex;\n  gap: 15px;\n  margin-bottom: 10px;\n}\n\n.metric-group {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex: 1;\n}\n\n.metric-input {\n  flex: 1;\n  text-align: right;\n}\n\n/* Blend Section */\n.blend-section {\n  margin: 10px 12px;\n}\n\n.blend-header {\n  font-weight: 600;\n  color: #0B2D71;\n  font-size: 13px;\n  margin-bottom: 8px;\n}\n\n/* Tables */\n.blend-table,\n.liquid-table {\n  width: 100%;\n  font-size: 11px;\n  margin-bottom: 8px;\n}\n\n.blend-table th,\n.liquid-table th {\n  padding: 6px 8px;\n  font-weight: 600;\n  font-size: 11px;\n  white-space: nowrap;\n}\n\n.blend-table td,\n.liquid-table td {\n  padding: 2px;\n  text-align: center;\n}\n\n/* Table Inputs */\n.numeric-input {\n  font-size: 11px;\n  text-align: right;\n}\n\n.container-input,\n.material-select {\n  font-size: 11px;\n}\n\n/* Buttons */\n.delete-btn {\n  color: #E21836;\n  font-size: 18px;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n  width: 15px;\n}\n\n.edit-btn,\n.icon-btn {\n  padding: 3px 10px 3px 8px;\n  background: #0066B2;\n  border: 1px solid #0066B2;\n  color: #fff;\n  font-size: 11px;\n  cursor: pointer;\n  border-radius: 2px;\n}\n\n.edit-btn:hover,\n.icon-btn:hover {\n  background: #004d8a;\n  border-color: #004d8a;\n}\n\n.edit-btn::after {\n  content: '›';\n  margin-left: 4px;\n  font-size: 16px;\n  font-weight: bold;\n  display: inline-block !important;\n}\n\n.add-btn {\n  padding: 5px 15px;\n  background: #0066B2;\n  color: #fff !important;\n  border: none;\n  font-size: 11px;\n  cursor: pointer;\n  border-radius: 3px;\n  margin-top: 5px;\n}\n\n/* Checkbox Toggle */\n.hidden-input {\n  display: none;\n}\n\ninput[type=\"checkbox\"]:checked ~ .hidden-input {\n  display: block;\n}\n\ninput[type=\"checkbox\"]:checked ~ .add-btn {\n  display: none;\n}\n\n/* Footer & Validation */\n.footer-actions {\n  display: flex;\n  gap: 8px;\n  padding: 12px 15px;\n  border: 1px solid #DBDCDD;\n  border-top: 2px solid #DBDCDD;\n}\n\n.validation-message {\n  color: #E21836;\n  padding: 4px 0;\n  margin: 8px 0 8px 12px;\n  font-size: 12px;\n}\n\n.validation-message-inline {\n  color: #E21836;\n  margin-top: 4px;\n  margin-left: 8px;\n  font-size: 11px;\n  display: inline-block;\n}\n\n/* Remove NextPage button arrows */\n.icon-btn::after,\n.add-btn::after {\n  display: none !important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
